import { render, staticRenderFns } from "./custompageec.vue?vue&type=template&id=8aa6975e"
import script from "./custompageec.vue?vue&type=script&lang=js"
export * from "./custompageec.vue?vue&type=script&lang=js"
import style0 from "./custompageec.vue?vue&type=style&index=0&id=8aa6975e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports